/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import dashboard from './dashboard'
import softwareworkflow from './software-workflow'
import company from './company'
import reports from './reports'
import support from './support'
import components from './components'

// Array of sections
export default [...dashboard, ...softwareworkflow, ...reports, ...components, ...company, ...support]
